import React, { useState } from 'react';
import { isEqual } from 'lodash';
import { useDisclosure } from '@podiumhq/design-system';
import { useTracking } from '@podiumhq/tracking';

import {
  EMAIL_FIELD,
  FIRST_NAME_FIELD,
  LAST_NAME_FIELD,
  PHONE_FIELD,
} from 'components/FormElements/constants';
import { useCheckoutContext } from 'contexts/CheckoutContextProvider';
import { hasValidFields } from 'lib/fieldValidation';

import { SelectPlanCheckoutPaymentFieldsWrapper } from '../../styles';

import ContactDetails from '../ContactDetails';
import { BillingContactInput } from '../FormItems';

import { EditModalWrapper } from './modals';

export const ContactDetailsSummary = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { userDetails = {}, setUserDetails } = useCheckoutContext();
  const { trackEvent } = useTracking();

  const [billingContact, setBillingContact] = useState(userDetails);
  const [billingContactErrors, setBillingContactErrors] = useState({});

  const closeModal = () => {
    trackEvent('selectPlanCheckout.billingContactInfo.exit');
    if (!isEqual(billingContact, userDetails)) {
      setBillingContact(userDetails);
    }
    onClose();
  };

  const openModal = () => {
    trackEvent('selectPlanCheckout.confirmDetails.contactChangeClicked');
    setBillingContactErrors({});
    onOpen();
  };

  const updateBillingContactDetails = () => {
    const isValid = hasValidFields(billingContact, setBillingContactErrors);

    if (isValid) {
      setUserDetails && setUserDetails(billingContact);
      onClose();
    }
  };

  const inputProps = {
    contactDetails: billingContact,
    errors: billingContactErrors,
    setContactDetails: setBillingContact,
    setErrors: setBillingContactErrors,
  };

  const getFieldProps = (fieldName) => ({ ...inputProps, fieldName });

  return (
    <>
      <ContactDetails openModal={openModal} />

      <EditModalWrapper
        handleSave={updateBillingContactDetails}
        headerTitle="Edit billing contact."
        isOpen={isOpen}
        onClose={closeModal}
      >
        <SelectPlanCheckoutPaymentFieldsWrapper>
          <BillingContactInput {...getFieldProps(FIRST_NAME_FIELD)} />
          <BillingContactInput {...getFieldProps(LAST_NAME_FIELD)} />
          <BillingContactInput {...getFieldProps(EMAIL_FIELD)} type="email" />
          <BillingContactInput
            mb="0"
            {...getFieldProps(PHONE_FIELD)}
            type="tel"
          />
        </SelectPlanCheckoutPaymentFieldsWrapper>
      </EditModalWrapper>
    </>
  );
};
